import i18n from 'modules/core/lib/i18n'

export const getFormatMinutesLabel = (minutes: number) => {
  const oneDayInMinutes = 60 * 24
  const oneWeekInMinutes = oneDayInMinutes * 7
  const oneMonthInMinutes = oneDayInMinutes * 30

  if (minutes < oneDayInMinutes) {
    return i18n.t('ats.insights_page.hiring_stages_bar_chart.chart_tooltip.zero_days')
  }

  const months = Math.floor(minutes / oneMonthInMinutes)
  minutes %= oneMonthInMinutes

  const weeks = Math.floor(minutes / oneWeekInMinutes)
  minutes %= oneWeekInMinutes

  const days = Math.floor(minutes / oneDayInMinutes)

  let result = ''
  if (months > 0) {
    result = i18n.t('ats.insights_page.hiring_stages_bar_chart.chart_tooltip.months', {
      amount: months,
    })
  }
  if (weeks > 0) {
    result = `${result} ${i18n.t('ats.insights_page.hiring_stages_bar_chart.chart_tooltip.weeks', {
      amount: weeks,
    })}`
  }
  if (days > 0) {
    result = `${result} ${i18n.t('ats.insights_page.hiring_stages_bar_chart.chart_tooltip.days', {
      amount: days,
    })}`
  }
  return result.trimStart()
}
